import { createSlice } from '@reduxjs/toolkit'

const {
  actions: {
    getAllAdminsStart,
    getAllAdminsSuccess,
    getAllAdminsFailure,
    getAdminDetailsStart,
    getAdminDetailsSuccess,
    getAdminDetailsFailure,
    getSuperAdminDetailsStart,
    getSuperAdminDetailsSuccess,
    getSuperAdminDetailsFailure,
    updateTenantAdminStatusStart,
    updateTenantAdminStatusComplete,
    getAllBonusStart,
    getAllBonusComplete,
    getAllBonusFailure,
    getAdminChildrenStart,
    getAdminChildrenSuccess,
    getAdminChildrenFailure,
    resetAdminChildren,
    getAdminDataStart,
    getAdminDataSuccess,
    getAdminDataFailure,
    updateReorderBonusStart,
    updateReorderBonusComplete,
    getLoggedSADetailsSuccess,
    getGroupsStart,
    getGroupsSuccess,
    getGroupsFailure,
    updateGroupStart,
    updateGroupComplete,
    getGroupDetailStart,
    getGroupDetailSuccess,
    getGroupDetailFailure,
    getRealityCheckDataStart,
    getRealityCheckDataComplete,
    setRealityCheckDataStart,
    setRealityCheckDataComplete,
    updateKYCTriggerSettingStart,
    updateKYCTriggerSettingComplete,
    createParentGroupStart,
    createParentGroupSuccess,
    createParentGroupFailure,
    updateParentGroupStart,
    updateParentGroupSuccess,
    updateParentGroupFailure,
    updateUserTagsStart,
    updateUserTagsComplete,
    boLogoUpdateStart,
    boLogoUpdateSuccess,
    boLogoUpdateFailure
  },
  reducer
} = createSlice({
  name: 'admins',
  initialState: {
    loading: false,
    error: null,
    success: false,
    data: null,
    adminDetails: null,
    adminRoleId: null,
    adminPermissions: null,
    adminChildren: null,
    adminData: null,
    superAdminUser: null,
    groupLoading: false,
    groupDetail: null,
    groupsList: {},
    realityCheckLoading: false,
    realityCheckData: {},
    updateKYCTriggerSettingLoading: false,
    boLogoLoader: false,
    boLogo: null
  },
  reducers: {
    getAllAdminsStart: (state) => ({
      ...state,
      loading: true
    }),
    getAllAdminsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      data: payload
    }),
    getAllAdminsFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    getAdminDetailsStart: (state) => ({
      ...state,
      loading: true
    }),
    getAdminDetailsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      adminDetails: payload
    }),
    getAdminDetailsFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    getSuperAdminDetailsStart: (state) => ({
      ...state,
      loading: true
    }),
    getSuperAdminDetailsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      adminDetails: payload,
      boLogo: payload?.boLogo,
      adminPermissions: payload?.userPermission?.permission,
      subModulePermissions: payload?.userPermission?.subModulePermissions,
      adminRoleId: payload?.superRoleId
    }),
    getSuperAdminDetailsFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    updateTenantAdminStatusStart: (state) => ({
      ...state,
      loading: true
    }),
    updateTenantAdminStatusComplete: (state) => ({
      ...state,
      loading: false
    }),
    getAllBonusStart: (state) => ({
      ...state,
      loading: true
    }),
    getAllBonusComplete: (state, { payload }) => ({
      ...state,
      loading: false,
      bonusList: payload

    }),
    getAllBonusFailure: (state) => ({
      ...state,
      loading: false
    }),
    getAdminChildrenStart: (state) => ({
      ...state,
      loading: true
    }),
    getAdminChildrenSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      adminChildren: payload
    }),
    getAdminChildrenFailure: (state, { payload }) => ({
      ...state,
      loading: false
    }),
    resetAdminChildren: (state) => ({
      ...state,
      loading: false,
      adminChildren: null
    }),
    getAdminDataStart: (state) => ({
      ...state,
      loading: true,
      adminData: null
    }),
    getAdminDataSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      adminData: payload
    }),
    getAdminDataFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    updateReorderBonusStart: (state) => ({
      ...state,
      loading: true
    }),
    updateReorderBonusComplete: (state) => ({
      ...state,
      loading: false
    }),
    getLoggedSADetailsSuccess: (state, { payload }) => ({
      ...state,
      superAdminUser: payload
    }),
    getGroupsStart: (state) => ({
      ...state,
      groupLoading: true
    }),
    getGroupsSuccess: (state, { payload }) => ({
      ...state,
      groupLoading: false,
      groupsList: payload
    }),
    getGroupsFailure: (state) => ({
      ...state,
      groupLoading: false
    }),
    updateGroupStart: (state) => ({
      ...state,
      groupLoading: true
    }),
    updateGroupComplete: (state) => ({
      ...state,
      groupLoading: false
    }),
    getGroupDetailStart: (state, action) => {
      // When fetching group details using the "Fetch Detail" button,
      // do not reload the page. Only update groupLoading if provided.
      return {
        ...state,
        groupLoading: action.payload.groupLoading || state.groupLoading
      }
    },
    getGroupDetailSuccess: (state, { payload }) => ({
      ...state,
      groupLoading: false,
      groupDetail: payload
    }),
    getGroupDetailFailure: (state) => ({
      ...state,
      groupLoading: false
    }),
    getRealityCheckDataStart: (state) => ({
      ...state,
      realityCheckLoading: true
    }),
    getRealityCheckDataComplete: (state, { payload }) => ({
      ...state,
      realityCheckLoading: false,
      realityCheckData: payload
    }),
    setRealityCheckDataStart: (state) => ({
      ...state,
      realityCheckLoading: true
    }),
    setRealityCheckDataComplete: (state) => ({
      ...state,
      realityCheckLoading: false
    }),
    updateKYCTriggerSettingStart: (state) => ({
      ...state,
      updateKYCTriggerSettingLoading: true
    }),
    updateKYCTriggerSettingComplete: (state) => ({
      ...state,
      updateKYCTriggerSettingLoading: false
    }),
    createParentGroupStart: (state) => ({
      ...state,
      groupLoading: true
    }),
    createParentGroupSuccess: (state) => ({
      ...state,
      groupLoading: false
    }),
    createParentGroupFailure: (state) => ({
      ...state,
      groupLoading: false
    }),
    updateParentGroupStart: (state) => ({
      ...state,
      groupLoading: true
    }),
    updateParentGroupSuccess: (state) => ({
      ...state,
      groupLoading: false
    }),
    updateParentGroupFailure: (state) => ({
      ...state,
      groupLoading: false
    }),
    updateUserTagsStart: (state) => ({
      ...state,
      loading: true
    }),
    updateUserTagsComplete: (state) => ({
      ...state,
      loading: false
    }),
    boLogoUpdateStart: (state) => ({
      ...state,
      boLogoLoader: true
    }),
    boLogoUpdateSuccess: (state, { payload }) => ({
      ...state,
      boLogoLoader: false,
      boLogo: payload
    }),
    boLogoUpdateFailure: (state) => ({
      ...state,
      boLogoLoader: false
    })
  }
})

export default reducer

export {
  getAllAdminsStart,
  getAllAdminsSuccess,
  getAllAdminsFailure,
  getAdminChildrenStart,
  getAdminChildrenSuccess,
  getAdminChildrenFailure,
  getAdminDetailsStart,
  getAdminDetailsSuccess,
  getAdminDetailsFailure,
  getSuperAdminDetailsStart,
  getSuperAdminDetailsSuccess,
  getSuperAdminDetailsFailure,
  updateTenantAdminStatusStart,
  updateTenantAdminStatusComplete,
  getAllBonusStart,
  getAllBonusComplete,
  getAllBonusFailure,
  resetAdminChildren,
  getAdminDataStart,
  getAdminDataSuccess,
  getAdminDataFailure,
  updateReorderBonusStart,
  updateReorderBonusComplete,
  getLoggedSADetailsSuccess,
  getGroupsStart,
  getGroupsSuccess,
  getGroupsFailure,
  updateGroupStart,
  updateGroupComplete,
  getGroupDetailStart,
  getGroupDetailSuccess,
  getGroupDetailFailure,
  getRealityCheckDataStart,
  getRealityCheckDataComplete,
  setRealityCheckDataStart,
  setRealityCheckDataComplete,
  updateKYCTriggerSettingStart,
  updateKYCTriggerSettingComplete,
  createParentGroupStart,
  createParentGroupSuccess,
  createParentGroupFailure,
  updateParentGroupStart,
  updateParentGroupSuccess,
  updateParentGroupFailure,
  updateUserTagsStart,
  updateUserTagsComplete,
  boLogoUpdateStart,
  boLogoUpdateSuccess,
  boLogoUpdateFailure
}
